import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { ApirequestService } from 'src/app/api/request/apirequest.service';
import { FormFunctions } from 'src/app/shared/functions/form-functions';
import { TabParamsInterface } from 'src/app/shared/interfaces/tab-params/tab-params-interface';
import { OpenRegisterComponent } from '../../components/dynamic-modals/open-register/open-register.component';
import { ActionButtonsService } from '../../services/action-buttons.service';
import { NotificationService } from '../../services/notification.service';
import { TabService } from '../../services/tab.service';
import { Tab } from '../../tab-models/tab.model';

@Component({
  selector: 'app-new-expert',
  templateUrl: './new-expert.component.html',
  styleUrls: ['./new-expert.component.scss']
})
export class NewExpertComponent implements OnInit, OnDestroy {

  @Input() tab: Tab;
  @Input() data: TabParamsInterface;

  public loading: boolean = false;
  public formExpert: FormGroup;

  private subscriptions: Array<Subscription> = [];

  private formFunctions = new FormFunctions;

  public heading = "<i class='fas fa-info-circle'></i> Datos del nuevo perito";

  modalRef: MDBModalRef | null = null;
  constructor(private modalService: MDBModalService, private _tabs: TabService, private _api: ApirequestService, private _buttons: ActionButtonsService, private _notification: NotificationService, private fb: FormBuilder) {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(e => e.unsubscribe());
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.formExpert = this.fb.group({
      identification_document: [null],
      name: [null, [Validators.required]],
      surname: [null],
      address: [null],
      email: [null],
      phone: [null],
      mobile: [null],
      postal_code: [null],
      province: [null],
      population: [null],
    });

    this.subscriptions.push(
      this.formExpert.valueChanges.subscribe(
        () => {
          this.tab.modifiedData = true;
        }
      )
    );
  };

  public onSubmit(): void {
    this.formExpert.markAllAsTouched();

    if (this.formExpert.valid) {

      this._buttons.setLoading(true);

      const params = {};
      this.formFunctions.fillFormParams(this.formExpert,this.data.entity, params);

      this.subscriptions.push(
        this._api.post(this.data.saveEndpoint, JSON.stringify(params)).subscribe(
          response => {
            let expert = response.response.expert
            this._buttons.reloadListTab(this.data.saveEndpoint)
            this._buttons.setLoading(false);
            this._notification.notificacionOK(this._notification.getInsertMsg())

            //Abre el modal de apertura de registro
            this.modalRef = this.modalService.show(OpenRegisterComponent, {
                    keyboard: false,
                    ignoreBackdropClick: true,
                    class: 'modal-dialog',
                    data: {
                heading: 'Registro Creado',
                text: 'Registro creado correctamente, ¿desea acceder al registro?',
                register: expert,
                form_entity: this.data.entity,
              }
            })

            this._tabs.removeTabByTabId(this.tab.tabId);
          },
          err => {
            this._buttons.setLoading(false);
          }
        )
      );
    }
  }

}
